import { FamilyApplicationResp } from '@/apis/family_application/requests'
import { isV1RenewalApplication } from '@/app/utils/student/student.utils'
import { AppRoutePaths } from '@/routing/route_paths'
import {
  FormEditState,
  selectMode,
  setEditMode,
} from '@/storage/applications/applicationStatusSlice'
import { AppDispatch } from '@/storage/store'
import { useDispatch, useSelector } from 'react-redux'
import { EDIT_PATHS_PER_FLAG } from './family-application-routing.constants'
import { FamilyApplicationRoutes } from './family-application.routing.types'
import {
  FamilyApplicationPaths,
  getIdentityVerificationUrl,
} from '@/routing/family_application_route_paths.ts'
import { selectProgramSettings } from '@/storage/program_settings/programSettingsSlice.ts'

function useFamilyApplicationRouting(familyApplication: FamilyApplicationResp) {
  const mode = useSelector(selectMode)
  const dispatch = useDispatch<AppDispatch>()
  const programSettings = useSelector(selectProgramSettings)

  function getEditStartPage(flag: FormEditState) {
    const start = EDIT_PATHS_PER_FLAG[flag].start
    if (start == FamilyApplicationPaths.identity_verification.index) {
      return getIdentityVerificationUrl(programSettings)
    }
    return start
  }

  const extractModulePath = (path: FamilyApplicationRoutes) => {
    const getPath = path.split('/')[3]
    return getPath
  }

  function onModuleEnd(nextRoute: FamilyApplicationRoutes): string {
    const startPage = getEditStartPage(mode)

    const isReviewPage =
      nextRoute === AppRoutePaths.family_application.review_application

    if (isReviewPage) {
      return nextRoute
    }

    const isRenewalApplication = isV1RenewalApplication(familyApplication)

    if (isRenewalApplication) {
      if (familyApplication.income_evaluated_by) {
        return AppRoutePaths.home.index
      } else {
        return nextRoute
      }
    }

    if (!familyApplication.submitted_at && mode == 'none') {
      return nextRoute
    }

    const usedEditButton =
      mode === 'form-edit-identity-verification' ||
      mode === 'form-edit-income-details' ||
      mode === 'form-edit-student-details'
    const routeBackPath = usedEditButton
      ? AppRoutePaths.family_application.review_application
      : AppRoutePaths.home.index

    const shouldEndAtLastSection = EDIT_PATHS_PER_FLAG[mode].end
    const isSinglePage = EDIT_PATHS_PER_FLAG[mode].isSinglePage

    if (isSinglePage) {
      return routeBackPath
    }

    if (shouldEndAtLastSection) {
      const isNewSection =
        extractModulePath(nextRoute) !== extractModulePath(startPage)
      if (isNewSection) {
        dispatch(setEditMode('none'))
        if (mode === 'dashboard-edit-student-details') {
          return AppRoutePaths.home.index
        } else {
          return routeBackPath
        }
      }
    }

    const hasReachedEnd = EDIT_PATHS_PER_FLAG[mode].end.includes(nextRoute)

    if (hasReachedEnd) {
      dispatch(setEditMode('none'))
      return routeBackPath
    }

    return nextRoute
  }

  return {
    onModuleEnd,
    getEditStartPage,
  }
}

export default useFamilyApplicationRouting
